export default __webpack_public_path__ + "static/Tengable-intro.oggtheora-ed17bc353d3ecfc2057ffba73e3539e9.ogv";